'use client'
import { ButtonRoundStyle } from '@/components'
import { RHFTextField } from '@/components/form'
import { Form } from '@/components/form/form-provider'
import { requestPasswordResetEmail } from '@/features/auth/services'
import yup from '@/utils/yup-global'
import { forgotPwSchema, identifierSchema } from '@/validations'
import { yupResolver } from '@hookform/resolvers/yup'
import { Stack } from '@mui/material'
import { useTranslations } from 'next-intl'
import { useTransition } from 'react'
import { useForm } from 'react-hook-form'
import { toast } from 'react-toastify'

type Props = {
  onNext?: (email: string) => void
}

export const RequestResetForm = ({ onNext }: Props) => {
  const [isPending, startTransition] = useTransition()
  const t = useTranslations('UserProfile')
  const method = useForm<yup.InferType<typeof identifierSchema>>({ resolver: yupResolver(identifierSchema) })
  const { handleSubmit } = method

  const onSubmit = (data: yup.InferType<typeof identifierSchema>) => {
    startTransition(async () => {
      try {
        const result = await requestPasswordResetEmail(data.identifier)

        if (result.status === 'error') {
          toast.error(result.message)
          return
        }

        toast.success(result.message)
        onNext?.(data.identifier)
      } catch (error) {
        console.error('Request reset error:', error)
        toast.error(t('Có lỗi xảy ra khi gửi yêu cầu đặt lại mật khẩu'))
      }
    })
  }

  return (
    <Form methods={method} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={2}>
        <RHFTextField
          autoFocus
          name="identifier"
          placeholder={t('Nhập email hoặc SĐT của bạn')}
          label={t('Vui lòng nhập e-mail hoặc số điện thoại của bạn')}
          disabled={isPending}
        />

        <ButtonRoundStyle variant="contained" type="submit" disabled={isPending} loading={isPending}>
          {t('Gửi mã xác minh')}
        </ButtonRoundStyle>
      </Stack>
    </Form>
  )
}
